<template>
  <div>
    <v-dialog :persistent="true" v-model="open" width="500">
      <v-card>
        <v-card-title class="text-h5"> ตั้งค่าอาจารย์ผู้สอน </v-card-title>

        <v-container fluid>
          <v-card elevation="1">
            <v-card-text>
              <div
                v-for="teacher in teachers"
                :key="teacher.teacher_id"
                class="teacher_item"
              >
                <v-btn
                  icon
                  color="red"
                  @click="deleteteacher(teacher.teacher_id)"
                >
                  <v-icon>mdi-trash-can</v-icon>
                </v-btn>
                {{ teacher.t_prename }} {{ teacher.teacher_name }}
                <span v-if="teacher.priority === '1'">(ผู้สอนหลัก)</span>
              </div>
            </v-card-text>
          </v-card>
        </v-container>

        <v-container fluid>
          <v-card elevation="1">
            <v-card-text>
              <v-autocomplete
                class="mt-2"
                v-model="selected_teacher"
                :items="teacherData"
                :item-text="(item) => `${item.t_prename} ${item.teacher_tname}`"
                :item-value="(item) => item.teacher_id"
                outlined
                dense
              >
              </v-autocomplete>
              <v-checkbox
                class="mt-0 pt-0"
                v-model="priority"
                label="เป็นผู้สอนหลัก"
              ></v-checkbox>
              <v-btn class="white--text green" @click="addteacher()"
                >เพิ่ม</v-btn
              >
            </v-card-text>
          </v-card>
        </v-container>

        <v-card-actions>
          <v-btn @click="close"> ปิด </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirm_delete_dialog" width="300">
      <v-card>
        <div class="red white--text">
          <v-card-title>ยืนยันการลบอาจารย์</v-card-title>
        </div>
        <v-card-actions>
          <v-btn outlined color="red" @click="confirm_deleteteacher()"
            >ยืนยันการลบอาจารย์</v-btn
          >
          <v-btn outlined color="dark" @click="confirm_delete_dialog = false"
            >ยกเลิก</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import tableTableProvider from "@/services/teach_table.provider.js";
const tableTableService = new tableTableProvider();
export default {
  name: "ConfigTeacherDialog",
  props: ["year", "semester", "fetch_data", "teacherData", "levelId"],
  data: () => ({
    open: false,
    teachers: [],
    item: null,
    selected_teacher: null,
    priority: true,
    confirm_delete_dialog: false,
    deleting_teacher: null,
  }),
  methods: {
    async open_dialog(item) {
      this.open = true;
      const data = await tableTableService.getTeacherSubject(
        item.teach_table_id,
        this.levelId
      );
      if (data && data.teacher_list) this.teachers = data.teacher_list;
      this.item = item;
    },
    async close() {
      this.open = false;
      await this.fetch_data();
    },
    deleteteacher(teacher_id) {
      this.deleting_teacher = teacher_id;
      this.confirm_delete_dialog = true;
    },
    async confirm_deleteteacher() {
      const data = await tableTableService.deleteTeacher(
        this.year,
        this.semester,
        this.item.subject_id,
        this.item.section,
        this.deleting_teacher,
        this.levelId,
        this.item.teach_table_id
      );
      if (data) {
        const data = await tableTableService.getTeacherSubject(
          this.item.teach_table_id,
          this.levelId
        );
        if (data && data.teacher_list) this.teachers = data.teacher_list;
      }
      this.confirm_delete_dialog = false;
    },

    async addteacher() {
      const data = await tableTableService.addTeacher(
        this.item.teach_table_id,
        this.selected_teacher,
        this.priority,
        this.levelId
      );
      if (data) {
        const data = await tableTableService.getTeacherSubject(
          this.item.teach_table_id,
          this.levelId
        );
        if (data && data.teacher_list) this.teachers = data.teacher_list;
      }
    },
  },
};
</script>

<style>
.teacher_item {
  padding: 3px;
  font-size: 15px;
  color: blue;
}
</style>
